var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreekIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.677 473.677",
    style: {
      enableBackground: "new 0 0 473.677 473.677"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFECEC"
    },
    d: "M236.842,0L236.842,0L236.842,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFECEC"
    },
    d: "M236.842,0h-0.007H236.842z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M88.101,421.095H385.58c0.037-0.03,0.067-0.052,0.101-0.079H88.003 C88.033,421.046,88.071,421.069,88.101,421.095z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFECEC"
    },
    d: "M318.881,104.977h114.715c-13.38-19.917-29.718-37.665-48.368-52.676H300.1 C307.617,67.496,313.87,85.345,318.881,104.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFECEC"
    },
    d: "M333.342,210.321h138.824c-2.038-18.268-6.152-35.907-12.094-52.676H328.851 C331.106,174.724,332.601,192.42,333.342,210.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFECEC"
    },
    d: "M328.899,315.672h131.285c5.923-16.776,10.015-34.408,12.023-52.676h-138.85 C332.624,280.898,331.143,298.59,328.899,315.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFECEC"
    },
    d: "M300.269,421.016h85.412c18.56-15.018,34.819-32.774,48.132-52.668H318.967 C313.978,387.966,307.756,405.811,300.269,421.016z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M292.607,52.302h92.622C344.624,19.61,293.037,0,236.842,0l0,0h-0.007 c-0.247,0-0.49,0.015-0.737,0.015C262.974,0.161,276.811,20.347,292.607,52.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M322.523,157.645h137.545c-6.653-18.758-15.572-36.431-26.476-52.668H312.554 C316.761,121.461,320.085,139.183,322.523,157.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M472.166,210.321H326.263c0.729,17.501,0.737,35.174,0.015,52.676h145.929 c0.942-8.597,1.47-17.31,1.47-26.155C473.677,227.875,473.138,219.034,472.166,210.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M311.349,368.348h122.464c10.867-16.252,19.756-33.925,26.375-52.676H321.282 C318.851,334.131,315.534,351.857,311.349,368.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M236.098,473.662c0.247,0,0.49,0.015,0.737,0.015c56.355,0,108.081-19.719,148.742-52.582h-92.341 C277.424,453.203,263.049,473.516,236.098,473.662z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4166AF"
    },
    d: "M300.101,52.302c-15.8-31.955-37.126-52.141-64.003-52.287 C180.195,0.191,128.884,19.749,88.46,52.302H300.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M300.101,52.302H88.456C69.81,67.312,53.472,85.06,40.088,104.977h278.789 C313.87,85.345,307.617,67.496,300.101,52.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4166AF"
    },
    d: "M318.881,104.977H40.092c-10.905,16.237-19.823,33.91-26.476,52.668h315.235 C326.409,139.183,323.08,121.461,318.881,104.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M13.616,157.645C7.67,174.414,3.56,192.053,1.522,210.321h331.82 c-0.737-17.901-2.236-35.601-4.491-52.676H13.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4166AF"
    },
    d: "M0,236.835v0.007c0,8.844,0.527,17.557,1.477,26.155h331.88c0.722-17.501,0.714-35.174-0.015-52.676 H1.518C0.55,219.034,0,227.875,0,236.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M13.496,315.672h315.403c2.244-17.082,3.725-34.774,4.454-52.676H1.477 C3.478,281.265,7.573,298.897,13.496,315.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4166AF"
    },
    d: "M39.871,368.348h279.096c4.185-16.491,7.502-34.217,9.932-52.676H13.496 C20.115,334.423,28.997,352.096,39.871,368.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M39.871,368.348c13.309,19.895,29.565,37.65,48.132,52.668h212.266 c7.487-15.205,13.709-33.05,18.698-52.668H39.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4166AF"
    },
    d: "M236.098,473.662c26.951-0.146,48.323-20.459,64.134-52.567H88.101 C128.585,453.812,180.034,473.486,236.098,473.662z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M236.835,0C106.043,0,0.007,106.032,0,236.835l1.477,26.162h235.365L236.835,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M98.968,44.329C75.85,60.918,55.817,81.526,39.954,105.19h59.014V44.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M13.672,157.47C4.85,182.289,0,208.994,0,236.835l1.477,26.162h97.491V157.47H13.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M236.842,105.19L236.835,0c-30.186,0-59.037,5.71-85.588,16.009v89.181H236.842z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.25,
    y: 157.46,
    style: {
      fill: "#3757A6"
    },
    width: 85.59,
    height: 105.53
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M151.247,105.19V16.009c-18.698,7.251-36.233,16.798-52.279,28.316v60.862H39.954 c-10.804,16.133-19.663,33.671-26.278,52.279h85.296v105.527v1.87h52.279v-1.87V157.47h85.595v-52.28H151.247L151.247,105.19z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreekIcon);
export default __webpack_public_path__ + "static/media/greek_icon.bec96f2e8e41e6105f2d6fc2e8190b35.svg";
export { ForwardRef as ReactComponent };